import { ErrorPayload, GetState, IoStateEnum, ThunkResult } from "#store/types";
import { OperatorInvocation } from "#services/pilotService/types";
import { action as createAction } from "@iva/store-utils";
import { Dispatch } from "redux";
import { pilotService } from "#services";
import { fetchInterpretationFromServer } from "#store/interpretations";
import {
    OperatorInvocationActionTypes,
    OperatorInvocationFailedActionType,
    OperatorInvocationIdentifiers,
    OperatorInvocationStartedActionType,
    OperatorInvocationState,
    OperatorInvocationSucceededActionType,
} from "#store/operatorInvocations/operatorInvocationTypes";
import { shouldRefetch } from "#/util/shouldRefetch";

function operatorFetchStarted(id: number): OperatorInvocationStartedActionType {
    return createAction(
        OperatorInvocationIdentifiers.FETCH_FROM_SERVER_STARTED,
        id
    );
}

function operatorFetchSucceeded(
    result: OperatorInvocation
): OperatorInvocationSucceededActionType {
    return createAction(
        OperatorInvocationIdentifiers.FETCH_FROM_FROM_SERVER_SUCCEEDED,
        result
    );
}

function operatorFetchFailed(
    error: ErrorPayload
): OperatorInvocationFailedActionType {
    return createAction(
        OperatorInvocationIdentifiers.FETCH_FROM_SERVER_FAILED,
        error
    );
}

export function fetchOperatorInvocationFromServer(id: number): ThunkResult {
    return (dispatch: Dispatch, getState: GetState) => {
        if (
            shouldRefetch(
                getState().operatorInvocations.operatorInvocations[id]
            )
        ) {
            dispatch(operatorFetchStarted(id));
            pilotService
                .operatorInvocationService(
                    getState().environment.SERVICE_URL,
                    getState().uiState.rid
                )
                .get(id)
                .then(result => {
                    dispatch(operatorFetchSucceeded(result));
                    result.interpretations.forEach(iId => {
                        dispatch(fetchInterpretationFromServer(iId));
                    });
                })
                .catch(error => {
                    dispatch(operatorFetchFailed({ error, id }));
                    console.warn(`failed to receive action ${id}`, error);
                });
        }
    };
}

// function operatorListFetchFailed(param: ErrorPayload) :{
//     return createAction(OperatorInvocationIdentifiers.FETCH_LIST_FAILED, param);
// }
//
export function listOperatorInvocationsFromServer(): ThunkResult {
    return (dispatch: Dispatch, getState: GetState) => {
        pilotService
            .operatorInvocationService(
                getState().environment.SERVICE_URL,
                getState().uiState.rid
            )
            .list()
            .then(operatorInvocations => {
                operatorInvocations.forEach(r => {
                    dispatch(operatorFetchSucceeded(r));
                });
            })
            .catch(err => {
                // TODO dispatch list action
                console.warn("Unable to retrieve operatorInvocations", err);
            });
    };
}

// The reducer function
export function operatorInvocationsReducer(
    state: OperatorInvocationState = {
        operatorInvocations: {},
    },
    action: OperatorInvocationActionTypes
): OperatorInvocationState {
    switch (action.type) {
        case OperatorInvocationIdentifiers.FETCH_FROM_SERVER_STARTED: {
            return {
                ...state,
                operatorInvocations: {
                    ...state.operatorInvocations,
                    [action.payload]: {
                        payload: null,
                        error: null,
                        timestamp: new Date(),
                        state: IoStateEnum.fetching,
                    },
                },
            };
        }
        case OperatorInvocationIdentifiers.FETCH_FROM_FROM_SERVER_SUCCEEDED: {
            // const newKey: string = String(action.payload.id);
            const newKey = action.payload.id;
            return {
                ...state,
                operatorInvocations: {
                    ...state.operatorInvocations,
                    [newKey]: {
                        payload: action.payload,
                        error: null,
                        state: IoStateEnum.done,
                        timestamp: new Date(),
                    },
                },
            };
        }
        case OperatorInvocationIdentifiers.FETCH_FROM_SERVER_FAILED: {
            return {
                ...state,
                operatorInvocations: {
                    ...state.operatorInvocations,
                    [action.payload.id]: {
                        payload: null,
                        error: action.payload,
                        state: IoStateEnum.error,
                        timestamp: new Date(),
                    },
                },
            };
        }
        default: {
            return state;
        }
    }
}
